<shared-navigation-top [title]="title"></shared-navigation-top>

<div class="content animation-fade-in">
  <user-personal-info-form></user-personal-info-form>
</div>